import { useFieldArray } from "react-hook-form";

import Table from "../../../../tables/components/Table";

import usePricesColumns from "../hooks/usePricesColumns";

import PricesFormTableActions from "./PricesFormTableActions";

export default function PricesFormTable() {
	const { fields, append, remove } = useFieldArray({
		name: "prices",
	});

	const pricesColumns = usePricesColumns({
		onRemove: (index) => remove(index),
	});

	return (
		<>
			<Table data={fields} columns={pricesColumns} style={{ overflow: "initial" }} />

			<PricesFormTableActions onAdd={(lastPrice) => append({ ...lastPrice, name: "" })} />
		</>
	);
}
